import {getLanguage, setLanguage} from '@/shared/services/i18n';

export async function afterSignIn() {
  await setLanguage(getLanguage());
}
